
import React from 'react';
import { BookOpen, CalendarDays, ShoppingCart, Lock, Check } from 'lucide-react';

interface StepIconProps {
  type: 'recipe' | 'recipe-collection' | 'meal-planning' | 'shopping-list';
  isComplete: boolean;
  isLocked: boolean;
}

const StepIcon: React.FC<StepIconProps> = ({ type, isComplete, isLocked }) => {
  const getBaseIcon = () => {
    switch (type) {
      case 'recipe':
      case 'recipe-collection':
        return BookOpen;
      case 'meal-planning':
        return CalendarDays;
      case 'shopping-list':
        return ShoppingCart;
    }
  };

  const BaseIcon = getBaseIcon();

  return (
    <div className="relative w-10 h-10 sm:w-12 sm:h-12 rounded-lg flex items-center justify-center transition-all duration-300 flex-shrink-0 bg-sage/10 hover:bg-sage/15">
      {isLocked ? (
        <Lock className="h-5 w-5 sm:h-6 sm:w-6 text-muted-foreground" />
      ) : isComplete ? (
        <Check className="h-5 w-5 sm:h-6 sm:w-6 text-sage" />
      ) : (
        <BaseIcon className="h-5 w-5 sm:h-6 sm:w-6 text-sage" />
      )}
    </div>
  );
};

export default StepIcon;
